import './habilitations.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';

import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import { create_role_habilitation, get_all_roles_habilitations, toggle_role_habilitation, update_role_habilitation } from '../../../services/habilitations service';


const columns = [
    { id: 'role_code', label: "Code", minWidth: 0 },
    { id: 'role_title', label: "Titre du rôle", minWidth: 0 },
    { id: 'habilitations', label: "Habilitations", minWidth: 0 },
    { id: 'is_active', label: "Actif", minWidth: 0 },
    // { id: 'actions', label: "Actions", minWidth: 0 },
];

function ActiveBadge({ is_active }) {
    return (
        <>
            {is_active
                ? <Button variant="contained" className="status_success">Actif</Button>
                : <Button variant="contained" className="status_deny">Inactif</Button>}
        </>
    );
}

function HabilitationsPreview({ habilitations }) {
    if (!habilitations) return <span>-</span>;
    const keys = Object.keys(habilitations);
    if (keys.length === 0) return <span>-</span>;

    const enabled = keys.filter(k => habilitations[k] === true);
    return (
        <div style={{ fontSize: ".85rem" }}>
            <b>{enabled.length}</b> activées / <b>{keys.length}</b> total
        </div>
    );
}


function RoleHabilitationModal({
    open,
    mode,
    data,
    allKeys,
    onClose,
    onSave
}) {
    const [roleCode, setRoleCode] = useState('');
    const [roleTitle, setRoleTitle] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [habilitations, setHabilitations] = useState({});

    useEffect(() => {
        if (!open) return;

        if (mode === "edit" && data) {
            setRoleCode(data.role_code ?? '');
            setRoleTitle(data.role_title ?? '');
            setIsActive(!!data.is_active);
            setHabilitations(data.habilitations ?? {});
        } else {
            // create defaults
            setRoleCode('');
            setRoleTitle('');
            setIsActive(true);

            // init habilitations with false by default for all keys
            const init = {};
            allKeys.forEach(k => init[k] = false);
            setHabilitations(init);
        }
    }, [open, mode, data, allKeys]);

    function toggleKey(key) {
        setHabilitations(prev => ({ ...prev, [key]: !prev[key] }));
    }

    const canSave = () => {
        if (mode === "create") {
            return roleCode.trim() !== '' && roleTitle.trim() !== '';
        }
        return roleTitle.trim() !== '';
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {mode === "create" ? "Ajouter un rôle / habilitations" : "Modifier habilitations"}
            </DialogTitle>

            <DialogContent>
                <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
                    <TextField
                        variant='standard'
                        label="Code rôle (ALL, 1, 2...)"
                        value={roleCode}
                        onChange={(e) => setRoleCode(e.target.value)}
                        fullWidth
                        disabled={mode === "edit"}
                    />
                    <TextField
                        variant='standard'
                        label="Titre du rôle"
                        value={roleTitle}
                        onChange={(e) => setRoleTitle(e.target.value)}
                        fullWidth
                    />
                </div>

                <div style={{ marginTop: "10px" }}>
                    <FormControlLabel
                        control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
                        label={isActive ? "Actif" : "Inactif"}
                    />
                </div>

                <div style={{ marginTop: "12px" }}>
                    <div style={{ fontWeight: 600, marginBottom: "6px" }}>Habilitations</div>

                    <div className="habilitations_grid">
                        <FormGroup>
                            {allKeys.map((key) => (
                                <FormControlLabel
                                    key={key}
                                    control={
                                        <Checkbox
                                            checked={!!habilitations[key]}
                                            onChange={() => toggleKey(key)}
                                        />
                                    }
                                    label={key}
                                />
                            ))}
                        </FormGroup>
                    </div>
                </div>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} className="submit_but cancel_but" variant="outlined">Annuler</Button>
                <Button
                    onClick={() => onSave({
                        role_code: roleCode.trim(),
                        role_title: roleTitle.trim(),
                        is_active: isActive,
                        habilitations
                    })}
                    variant="contained"
                    className="submit_but valide_but"
                    disabled={!canSave()}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Habilitations_list() {
    const history = useHistory();

    const [url_updated, setUrl_updated] = useState(null);

    const [rules, setRules] = useState(null);
    const [waiting, setWaiting] = useState(false);

    // pagination (front-only)
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage] = useState(8);
    const [data_count, setData_count] = useState(0);

    // modal
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("edit"); // create/edit
    const [selectedRule, setSelectedRule] = useState(null);

    // keys for habilitations (union of all keys)
    const [allKeys, setAllKeys] = useState([
        "Création des DAS",
        "Consultation des DAS",
        "Validation des DAS",
        "Consultation des factures",
        "Consultation du stock",
        "Gestion du stock",
        "Gestion des projets",
    ]);

    useEffect(() => {
        setRules(null);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let page = (urlParams.get('page') ? Number(urlParams.get('page')) : 1);
        setCurrentPage(page);

        async function load_data() {
            try {
                const res = await get_all_roles_habilitations();
                const arr = res.data || [];
               //  console.log(arr);

                // build union keys from backend data
                const keySet = new Set(allKeys);
                arr.forEach(r => {
                    if (r?.habilitations) {
                        Object.keys(r.habilitations).forEach(k => keySet.add(k));
                    }
                });
                setAllKeys(Array.from(keySet));

                setData_count(arr.length);
                setRules(arr);
            } catch (e) {
               //  console.log(e?.response || e);
                setRules([]);
            }
        }

        load_data();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url_updated, history.location]);

    // pagination slicing
    /* const paginatedData = () => {
       if (!rules) return [];
       const start = (currentPage - 1) * dataPerPage;
       const end = start + dataPerPage;
       return rules.slice(start, end);
     };
   
     async function change_page(page) {
       setCurrentPage(page);
   
       let path = history.location.pathname;
       let params = history.location.search;
       let search_params = params.split('&');
       let tmp_params = path;
   
       if (!params) history.push(path + "?page=" + page);
       else {
         for (let i in search_params) {
           if (search_params[i].includes("page=")) {
             if (i == 0) tmp_params = tmp_params + "?page=" + page;
             else tmp_params = tmp_params + "&page=" + page;
           } else {
             if (i == 0) tmp_params = tmp_params + search_params[i];
             else tmp_params = tmp_params + "&" + search_params[i];
           }
         }
         if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
         history.push(tmp_params);
       }
   
       setUrl_updated(page);
     }*/

    function openCreate() {
        setModalMode("create");
        setSelectedRule(null);
        setModalOpen(true);
    }

    function openEdit(rule) {
        setModalMode("edit");
        setSelectedRule(rule);
        setModalOpen(true);
    }

    async function onSave(payload) {
        try {
            setWaiting(true);

            if (modalMode === "create") {
                await create_role_habilitation(payload);
            } else {
                await update_role_habilitation(selectedRule.role_code, {
                    role_title: payload.role_title,
                    habilitations: payload.habilitations,
                    is_active: payload.is_active,
                });
            }

            setModalOpen(false);
            setSelectedRule(null);
            setUrl_updated(Date.now());
            setWaiting(false);
        } catch (e) {
           //  console.log(e?.response || e);
            setWaiting(false);
        }
    }

    async function toggleActive(rule) {
        try {
            setWaiting(true);
            await toggle_role_habilitation(rule.role_code);

            // update local state quickly
            const tmp = [...rules];
            const idx = tmp.findIndex(r => r.role_code === rule.role_code);
            if (idx !== -1) tmp[idx].is_active = !tmp[idx].is_active;
            setRules(tmp);

            setWaiting(false);
        } catch (e) {
           //  console.log(e?.response || e);
            setWaiting(false);
        }
    }

    async function removeRule(rule) {
        /*try {
          setWaiting(true);
          await delete_role_habilitation(rule.role_code);
    
          const tmp = rules.filter(r => r.role_code !== rule.role_code);
          setRules(tmp);
          setData_count(tmp.length);
    
          setWaiting(false);
        } catch (e) {
         //  console.log(e?.response || e);
          setWaiting(false);
        }*/
    }

    return (
        <>
            {rules === null
                ? <Loading_animation_view />
                : <div className='services_list_container'>
                    <div className='services_list_container_header'>
                        <div className='title_container'>
                            <label>Gestion des habilitations</label>
                            <Button variant="contained" className={waiting ? "submit_but disabled_button" : "submit_but"} startIcon={<AddIcon />} onClick={openCreate}>
                                Ajouter
                            </Button>
                        </div>
                    </div>

                    <TableContainer className="services_list_table">
                        <Table aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align="left">{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rules.length !== 0
                                    ? rules.map((rule, id) => (
                                        <TableRow key={"rule_" + id}>
                                            <TableCell align="left">
                                                <div style={{ width: 'fit-content' }}>
                                                    {rule.role_code}
                                                    <div style={{ width: '100%', display: 'flex' }}>
                                                        <Tooltip title="Modifier" placement="top">
                                                            <span className="editIcon" onClick={() => openEdit(rule)}>
                                                                <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left">{rule.role_title}</TableCell>
                                            <TableCell align="left">
                                                <HabilitationsPreview habilitations={rule.habilitations} />
                                            </TableCell>
                                            <TableCell align="left">
                                                <div className='documentsStatus_valide'>
                                                    <div>
                                                        <div>
                                                            <Tooltip title="Activer" placement="top">
                                                                <span>
                                                                    <CheckIcon className="checkIcon" onClick={() => toggleActive(rule)} />
                                                                </span>
                                                            </Tooltip>
                                                        </div>
                                                        <div>
                                                            <Tooltip title="Désactiver" placement="top">
                                                                <span>
                                                                    <CloseSharpIcon className="closeSharpIcon" onClick={() => toggleActive(rule)} />
                                                                </span>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    <ActiveBadge is_active={!!rule.is_active} />
                                                </div>
                                            </TableCell>
                                            {/*  <TableCell align="left">
                                                <div style={{ display: "flex", gap: "10px" }}>
                                                    {rule.role_code !== "ALL" && (
                                                        <Tooltip title="Supprimer" placement="top">
                                                            <span className="deleteIcon" onClick={() => removeRule(rule)}>
                                                                <DeleteIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                                            </span>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </TableCell> */}
                                        </TableRow>
                                    ))
                                    : <TableRow>
                                        <TableCell colSpan={5} align="center" style={{ padding: "20px" }}>
                                            Aucune règle disponible
                                        </TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/*rules.length !== 0 &&
            <div className="pagination_container">
              <Pagination
                activePage={Number(currentPage)}
                itemsCountPerPage={dataPerPage}
                totalItemsCount={Number(data_count)}
                pageRangeDisplayed={4}
                onChange={change_page.bind(this)}
              />
            </div>
          */}
                </div>
            }
            {
                modalOpen != false
                    ? <RoleHabilitationModal
                        open={modalOpen}
                        mode={modalMode}
                        data={selectedRule}
                        allKeys={allKeys}
                        onClose={() => setModalOpen(false)}
                        onSave={onSave}
                    />
                    : <></>
            }

            <Backdrop className='waiting_backdrop' open={waiting}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default Habilitations_list;
